import { render, staticRenderFns } from "./vs-tabs.vue?vue&type=template&id=02842c59&scoped=true"
import script from "./vs-tabs.vue?vue&type=script&lang=js"
export * from "./vs-tabs.vue?vue&type=script&lang=js"
import style0 from "./vs-tabs.vue?vue&type=style&index=0&id=02842c59&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02842c59",
  null
  
)

export default component.exports